import Breadcrumb from "Components/Common/Breadcrumb";
import React from "react";
import { Container } from "reactstrap";
function Accounts() {
  document.title = "Ditobanx";

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumb title="Dashboards" breadcrumbItem="Accounts" />
          <h4>CUENTAS</h4>
        </Container>
      </div>
    </React.Fragment>
  );
}

export default Accounts;
